itsoftApp.createModule("formsValidation", ["pageLoad"], function() {
    var $document, defaultParsleyOptions, errorMsgWrapperClass, forms, inputWrapperClass, loadLibrary, sendingClass, serverErrorsClass, state2Class, state2HideDelay;
    forms = $(".js-form-validate");
    if (!forms.length) {
        return false;
    }
    errorMsgWrapperClass = "form__error-msg";
    inputWrapperClass = "form__input-wrapper";
    defaultParsleyOptions = {
        errorClass: "is-error",
        successClass: "is-success",
        errorsWrapper: "<div class=\"" + errorMsgWrapperClass + "\"></div>",
        classHandler: function(ParsleyField) {
            return ParsleyField.$element.closest("." + inputWrapperClass);
        },
        errorTemplate: "<div></div>"
    };
    $document = itsoftApp.commonVars.$document;
    state2Class = "is-state-2";
    sendingClass = "is-sending";
    state2HideDelay = 4000;
    serverErrorsClass = "js-form-errors";
    loadLibrary = function() {
        return itsoftApp.loadScript("/assets/scripts/parsley.min.js", function() {
            DEBUG && console.log("[module formsValidation] parsley.js library loaded, ready to initialize module");
            return forms.each(function() {
                var ajaxSubmit, error, form, parsleyInstance, submit, success;
                form = $(this);
                ajaxSubmit = form.attr("data-ajax-submit") === "true";
                success = function() {
                    return DEBUG && console.log("[module formsValidation] validation success");
                };
                error = function() {
                    return DEBUG && console.log("[module formsValidation] validation error");
                };
                submit = function() {
                    document.getElementById("check").value = "s-s";
                    DEBUG && console.log("[module formsValidation] validation submit");
                    if (ajaxSubmit) {
                        return (function() {
                            var ajaxRecieved, always, data, done, fail, formAction, popup, request, setState2, singleClose, unsetState2;
                            popup = form.closest(".popup");
                            formAction = form.attr("action");
                            ajaxRecieved = false;
                            data = form.serializeArray();
                            DEBUG && console.log("[module formsValidation] serialized data:");
                            DEBUG && console.log(data);
                            singleClose = function() {
                                return setTimeout(unsetState2, 500);
                            };
                            setState2 = function() {
                                DEBUG && console.log("[module formsValidation] set state-2");
                                form.addClass(state2Class);
                                if (popup.length) {
                                    popup.one("popups:close", singleClose);
                                    return setTimeout(function() {
                                        return popup.trigger("popups:close");
                                    }, 4000);
                                } else {
                                    return setTimeout(singleClose, state2HideDelay);
                                }
                            };
                            unsetState2 = function() {
                                DEBUG && console.log("[module formsValidation] unset state-2");
                                return form.removeClass(state2Class);
                            };
                            done = function(data) {
                                var $data, elemForScroll, scrTop, serverErrorsElem;
                                $data = $(data);
                                serverErrorsElem = $data.find("." + serverErrorsClass);
                                DEBUG && console.log("[module formsValidation] ajax done. data.length: " + data.length + ". errorsFound: " + (serverErrorsElem.length > 0));
                                form.find("." + serverErrorsClass).remove();
                                if (!serverErrorsElem.length) {
                                    setState2();
                                    return form.data("validation-passed", "false").trigger("reset");
                                } else {
                                    form.prepend(serverErrorsElem);
                                    elemForScroll = popup.length ? popup : $document;
                                    scrTop = serverErrorsElem.offset().top - window.innerHeight / 2;
                                    return elemForScroll.animate({
                                        scrollTop: scrTop
                                    });
                                }
                            };
                            fail = function(err) {
                                return DEBUG && console.log("[module formsValidation] ajax fail. error: ", err);
                            };
                            always = function() {
                                form.removeClass(sendingClass);
                                ajaxRecieved = true;
                                return DEBUG && console.log("[module formsValidation] ajax always");
                            };
                            setTimeout(function() {
                                if (!ajaxRecieved) {
                                    return form.addClass(sendingClass);
                                }
                            }, 300);

                            request = $.ajax({
                                url: formAction,
                                method: "POST",
                                data: data
                            });
                            request.done(done);
                            request.fail(fail);
                            request.always(always);
                            return false;
                        })();
                    }
                };
                parsleyInstance = form.parsley(defaultParsleyOptions);
                parsleyInstance.on("form:success", success);
                parsleyInstance.on("form:error", error);
                return parsleyInstance.on("form:submit", submit);
            });
});
};
return itsoftApp.modules.pageLoad.addEvent(loadLibrary);
});
